import React from "react";
import { PageHeader, Button, Icon, Col, Row } from "antd";


export default function Header(props) {
  return (
    <PageHeader
      title={
        <div>
          <Icon type="container" />
          &nbsp;&nbsp;<span>{props.title}</span>
        </div>
      }
      extra={[
        <div key="1">

          {props.viewCabecera ? null : (
            <Button
              icon="left-circle"
              type="success"
              onClick={props.onReturn}
              className="ml-10"
            >
              Regresar
            </Button>
          )}

          {props.onNew === undefined ? null : (
            <Button
              icon="plus"
              type="primary"
              loading={props.loadingNew}
              onClick={props.onNew}
              className="ml-10"

            >
              Nuevo
            </Button>
          )}
          {props.viewCabecera ? null : (
            <Button
              icon="dollar"
              type="success"
              onClick={props.onDevolucion}
              className="ml-10"
              ghost
            >
              Devolver saldos pendientes
            </Button>
          )}


          {props.onSearch === undefined ? null : (
            <Button icon="search" type="primary" ghost onClick={props.onSearch} className="ml-10">
              Buscar
            </Button>
          )}

          {props.onClearFilters === undefined ? null : (
            <Button icon="shake" type="primary" ghost onClick={props.onClearFilters} className="ml-10">
              Limpiar
            </Button>
          )}
        </div>,
      ]}
    ></PageHeader>
  );
}
